import angular from 'angular';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { UserService } from '../../tn.user/service.tn.user';
import billingSavedCreditCardsTemplate from '../partials/billingSavedCreditCards.html';

BillingDirectiveSavedCreditCards.$inject = [
    'tn.stripe.service',
    'tn.user.service',
    '$tnPopover',
];

export default function BillingDirectiveSavedCreditCards(
    stripeService,
    userService: UserService,
    $tnPopover: PopoverService
) {
    return {
        scope: {
            creditCards: '=',
            defaultCard: '=',
            selectedCard: '=',
        },
        template: billingSavedCreditCardsTemplate,
        link: function (scope) {
            const removeCardPopover = $tnPopover.popoverXS(
                angular.element('.popover-saved-card-remove')
            );
            let removeThisCard;

            if (userService.isLoggedIn()) {
                stripeService.getCardsFromStripe();
            }

            scope.user = userService.getUser();

            scope.$watch('defaultCard.default', function (defaultCard) {
                // Verify that the selected card is in the creditCard List
                function _selectedCardIsValid() {
                    return scope.creditCards.some(
                        (card) => card.id === scope.selectedCard.card
                    );
                }

                //Prevent setting to null
                if (
                    defaultCard &&
                    (!scope.selectedCard.card || !_selectedCardIsValid())
                ) {
                    if (defaultCard) {
                        scope.selectedCard.card = defaultCard;
                    } else {
                        scope.selectedCard.card = 'new';
                    }
                }
            });

            scope.currentDate = new Date();

            scope.deleteCard = function (card) {
                stripeService.deleteCardFromStripe(card);
                if (
                    card.id === scope.selectedCard.card &&
                    scope.creditCards.length
                ) {
                    scope.selectedCard.card = scope.creditCards[0].id;
                }
            };

            scope.removeSavedCard = function () {
                if (removeThisCard) {
                    scope.deleteCard(removeThisCard);
                }
                removeThisCard = null;
                removeCardPopover.hide();
            };

            scope.showRemoveCardPopover = function ($event, card) {
                removeThisCard = card;
                removeCardPopover.show($event.currentTarget);
            };
        },
    };
}
